// extracted by mini-css-extract-plugin
module.exports = {"planTypeContainer":"styles-module__planTypeContainer___2tKyl"};